import './book-event-info.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Event } from '../../../../store/events/eventTypes';

interface Props {
  event: Event;
}

const BookEventInfo = ({ event }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="book-event-info">
      <div className="book-event-info-name-title">{event.name}</div>
      <div className="book-event-info-image">
        <img src={event.image} alt="event image" />
      </div>
      <div className="book-event-info-description">
        {event.description || 'No description'}
      </div>
      <div className="book-event-warning">{t('BOOK_EVENT_WARNING')}</div>
    </div>
  );
};

export default BookEventInfo;
